import { createFileRoute } from "@tanstack/react-router";
import { parseLang } from "@majourneys/shared";
import { BlogListPage } from "../../../features/blog";
import {
  blogListFilters,
  blogListQueryOptions,
  type BlogListSearch,
} from "../../../features/blog/hooks/use-blogs";
import { recentPostsQueryOptions } from "../../../features/blog/hooks/use-recent-posts";

export const Route = createFileRoute("/$lang/_layout/blog/")({
  // Prefetch the post list so `useBlogs` (a suspense query) resolves during
  // SSR. Without it the server sent only the spinner and crawlers saw a blog
  // index with no article links. Keyed on page, category and search so
  // pagination and filters stay in the URL and each view prerenders.
  loaderDeps: ({ search }: { search: BlogListSearch }) => ({
    page: search.page,
    category: search.category,
    search: search.search,
  }),
  loader: async ({ context, params, deps }) => {
    const lang = parseLang(params.lang);
    const filters = blogListFilters(deps);
    const unfiltered = filters.page === 1 && !filters.category && !filters.search;
    await Promise.all([
      context.queryClient.ensureQueryData(blogListQueryOptions(lang, filters)),
      // The sidebar reads recent posts on every view except the unfiltered
      // first page. Best-effort: a hiccup there must not fail the list.
      unfiltered
        ? undefined
        : context.queryClient
            .ensureQueryData(recentPostsQueryOptions(lang))
            .catch(() => undefined),
    ]);
  },
  component: BlogListPage,
});
